import { render, staticRenderFns } from "./BusinesserEdit.vue?vue&type=template&id=7a151712&"
import script from "./BusinesserEdit.vue?vue&type=script&lang=js&"
export * from "./BusinesserEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports